import { BaseApiResponseWithPagination, CoderProfile } from '../../types/shared.types';
import * as type from '../ActionTypes';

export interface ICodersState {
  coders: BaseApiResponseWithPagination<CoderProfile>;
  loadingCoders: boolean;
  recommendedCoders: CoderProfile[];
  loadingRecommendedCoders: boolean;
  error: any;
  setShowMessages?: any;
}

const serverStateCoder: BaseApiResponseWithPagination<CoderProfile> = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  total_pages: 0
};

const initialState: ICodersState = {
  coders: serverStateCoder,
  loadingCoders: true,
  recommendedCoders: [],
  loadingRecommendedCoders: false,
  error: null
};

export default function codersReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_CODERS_LIST:
      return {
        ...state,
        loadingCoders: true,
        coders: serverStateCoder
      };
    case type.GET_CODERS_LIST_SUCCESS:
      return {
        ...state,
        coders: action.payload,
        loadingCoders: false
      };
    case type.GET_CODERS_LIST_FAILURE:
      return {
        ...state,
        error: action.payload,
        loadingCoders: false,
        coders: { ...serverStateCoder }
      };
    case type.CLEAR_CODERS_LIST:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}
